export default __webpack_public_path__ + "070d9745298c985463fa73fdfa14e938.png";